/**
 *  Filters constant module file
**/

export const MODULE_NAME = 'filters'

export const ACTIONS = {}

export const GETTERS = {}

export const MUTATIONS = {
  SET_FILTER_VALUE: 'setFilterValue',
  TOGGLE_FILTER: 'toggleFilter',
  CLEAR_ALL_FILTERS: 'clearAllFilters'
}
